const selectors = {
    productReasons: document.querySelector('[data-reasons]'),
    reasonGiftSelectbox: document.querySelector('#ProductForm-reasonGift'),
    appendSelect: document.querySelector('[data-append-select]'),
    reasonMessage: document.querySelector('[data-reasonMessage]'),
    submitBtn: document.querySelector('[data-submitBtn]'),

    /**
     * card functionality
     */

    cardItem: document.querySelectorAll('input[name="properties[gift_card]"]'),
    selectedCard: document.querySelector('[data-selected-card]')
  };

  class TemplateProductJS {
    constructor() {
      this.reason();
    }
    /**
     * Initialize the findGift component
     */
    reason() {
      if (selectors.selectedCard){
        selectors.cardItem.forEach((input) => {
          input.addEventListener('change', () => {
            let cardValue = document.querySelector('input[name="properties[gift_card]"]:checked').value;

            if (cardValue) {
              selectors.selectedCard.innerHTML = `${cardValue}`;
            } else {
              selectors.selectedCard.innerHTML = '';
            }
          });
        });
      }

      if (selectors.productReasons){
        const json = selectors.productReasons.innerHTML;
        const reasonJson = JSON.parse(json);
    
        selectors.reasonGiftSelectbox.addEventListener('change', (event) => {
          let currentTarget = event.currentTarget;
          reasonJson.forEach(element => {
            if (element.gift_reason == currentTarget.value){

              let option = '';
              element.gift_messages.forEach(item => {
                option += `<option value="${item}">${item}</option>`;
              });
    
              selectors.appendSelect.innerHTML = `
              <label for="ProductForm-heleText" class="fw-medium mb-1">Let Us Help You Write A Message: <span class="text-danger">*</span></label>
              <select name="properties[_help_text]" class="form-select" id="ProductForm-heleText" required>
                <option value="">Start your message with our Words of Expression</option>
                ${option}
              </select>`;
              selectors.appendSelect.querySelector('select').addEventListener('change', (e) => {
                let e_currentTarget = e.currentTarget;
                selectors.reasonMessage.querySelector('textarea').value = e_currentTarget.value;
              });
              selectors.reasonMessage.classList.remove('d-none');
              selectors.submitBtn.classList.remove('disabled-btn');
            } else if(currentTarget.value == 'default'){
              selectors.appendSelect.innerHTML = "";
              selectors.reasonMessage.querySelector('textarea').value = '';
              selectors.reasonMessage.classList.add('d-none');
              selectors.submitBtn.classList.add('disabled-btn');
            }
          });
        });
      }
     
    }
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();
